import axios from 'axios'
import { buildRequestPrerequisites } from './dataService'

export const saveFyusionSession = async ({ globalState, params }) => {
  const { headers, baseUrl, apiKey } = buildRequestPrerequisites({ globalState })
  const { sessionId, vin, dealerGuid } = params
  const baseEndpoint = `${baseUrl}/fyusion/session`
  try {
    const { data, status } = await axios.post(
      baseEndpoint,
      {
        SessionId: sessionId,
        Vin: vin,
        DealerId: dealerGuid
      },
      {
        headers,
        params: {
          api_key: apiKey
        }
      }
    )

    return {
      data,
      error: null,
      status
    }
  } catch (error) {
    return { data: null, error, status: error.response?.status }
  }
}
